module.exports = __webpack_public_path__ + "media/volvo/assets/images/hero_background-fae39ce0e257e5e84de8f26e05e89bb2.jpg";